




































import { Component, Prop } from "vue-property-decorator";
import { QuestionFlowService } from "@/core/services";

import AppVue from "@/AppVue.vue";
import { QuestionFlow } from "@/core/models/questionFlow";
import { Answer, Question, EndResult } from "@/core/models/question.model";
import InputRadioCpt from "@/core/components/InputRadioCpt.vue";
import locale from "element-ui/lib/locale/lang/en";
import QuestionCard from "./QuestionCard.vue";
import MultiLineString from "./MultiLineString.vue";
import PreambleCard from "./PreambleCard.vue";
import EndCard from "./EndCard.vue";

// extending the window interface to include the currentLanguage passed by umbraco
declare global {
  interface Window {
    currentLanguage: string;
  }
}

@Component({
  components: {
    QuestionCard,
    PreambleCard,
    EndCard,
    MultiLineString,
  },
})
export default class HomeView extends AppVue {
  flow: QuestionFlow;
  currentNode: Question | EndResult = {} as Question;
  previousPath: Question[] = [];
  language: string;
  answerCode: any = null;
  created() {
    this.language = window.currentLanguage || "en";
    this.flow = QuestionFlowService.createFlow();
    this.currentNode = this.flow.start();
  }

  onAnswerSelected(code: string) {
    this.answerCode = code;
  }
  getSelectedAnswer(answers: Answer[]): Answer | undefined {
    return answers.find(x => x.Selected);
  }

  next() {
    if (this.currentNode.Type === "preamble") {
      const preamble = this.currentNode as Question;
      this.previousPath.push(preamble);
      this.currentNode = preamble.Next();
      return;
    }
    if (!this.answerCode) {
      return;
    }
    const q = this.currentNode as Question;
    if (!q) {
      return;
    }
    // reset
    q.Answers.forEach(x => (x.Selected = false));
    const currentAnswer = q.Answers.find(x => x.Code === this.answerCode);
    if (!currentAnswer) {
      return;
    }
    currentAnswer.Selected = true;
    this.previousPath.push(q);
    this.currentNode = currentAnswer.DestinationResolver();
    // check for duplicated questions
    if (this.previousPath.find(x => x.Code === this.currentNode.Code)) {
      this.currentNode = this.flow.end();
    }
    this.answerCode = null;
  }
  previous() {
    if (this.previousPath && this.previousPath.length > 0) {
      this.currentNode = this.previousPath.pop() as Question;
      this.answerCode = null;
      if (this.currentNode.Type === "preable" || !this.currentNode.Answers) {
        return;
      }
      this.currentNode.Answers.forEach(x => {
        if (x.Selected) {
          this.answerCode = x.Code;
        }
      });
    }
  }
}
